import React, { useState } from 'react';
import { HelpText as HelpTextComponent, Label } from '@gjensidige/builders-components';
import tracker  from '../../tracking.js';

interface HelpTextProps {
  message: string;
  helpTextClassName: string;
  labelText?: string;
  referenceId?: string
}

export const HelpText: React.FC<HelpTextProps> = ({message, labelText, helpTextClassName='', referenceId=''}: HelpTextProps) => {
  const {scenario_name, scenario_step} = tracker.getOptions();
  const [isToggled, setIsToggled] = useState(false);
  
  return (
    <>
      <Label 
         htmlFor={referenceId}
         className={helpTextClassName}
      >
        {labelText}
      </Label>
      <HelpTextComponent
        children={
          message?.split('\n').map((text: string, index: number) => {
            return message.length !== index + 1 ? (
              <span 
                key={index} 
                dangerouslySetInnerHTML={{
                __html: `${text}<br />`
              }}/>

            ) : (
              <span 
                dangerouslySetInnerHTML={{
                __html: text
              }}/>
            );
          })
        }
        toggle={isToggled ? `Stäng hjälptext för ${labelText}` : `Visa hjälptext för ${labelText}`}
        open={isToggled}
        onToggle={() => setIsToggled(!isToggled)}
        className={helpTextClassName}
        tracking={{
          // @ts-expect-error
          scenario_name,
          scenario_step,
          eventLabel: labelText
        }}
        htmlFor={referenceId}
      />
    </>
  );
};
